/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

const reportBuilder = createSlice({
    name: "reportBuilder",
    initialState: {
        currentSelectedMode: "",
        mode: "select", // fullmarket, singlecategory,
        settingShowZero: false,
        whiteSpaceChartPDF: {}
    },
    reducers: {
        setCurrentSelectedMode: (state, action) => ({ ...state, currentSelectedMode: action.payload }),
        setReportBuilderMode: (state, action) => ({ ...state, mode: action.payload }),
        setSettingShowZero: (state, action) => ({ ...state, settingShowZero: action.payload }),
        setWhiteSpaceChartPDF: (state, action) => {
            const { key, value } = action.payload;
            return ({
                ...state,
                whiteSpaceChartPDF: {
                    ...state.whiteSpaceChartPDF,
                    [key]: value
                }
            });
        },
        setReportBuilderFromLoadedJson: (state, action) => {
            Object.keys(action.payload).forEach((key) => {
                state[key] = action.payload[key];
            });
        },
        clearWhiteSpaceChartPDF: (state, action) => ({ ...state, whiteSpaceChartPDF: {} })
    }
});

const { reducer, actions } = reportBuilder;
export const {
    setReportBuilderMode,
    setCurrentSelectedMode,
    setReportBuilderFromLoadedJson, setSettingShowZero, setWhiteSpaceChartPDF, clearWhiteSpaceChartPDF
} = actions;
export default reducer;
